import type { CmtsBackendEndpoint } from "./cmtsBackendEndpointRegistry.js";

export const CMTS_SOURCE_ONLY_ENDPOINTS = [
  {
    key: "Evidence_List_GET_SOURCE_0", controller: "EvidenceController", controllerGroup: "Evidence", action: "List", method: "GET", path: "/complaints/{complaintId}/evidence",
    params: [{"name": "complaintId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_AddMetadata_POST_SOURCE_1", controller: "EvidenceController", controllerGroup: "Evidence", action: "AddMetadata", method: "POST", path: "/complaints/{complaintId}/evidence/metadata",
    params: [{"name": "complaintId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_PackageManifest_GET_SOURCE_2", controller: "EvidenceController", controllerGroup: "Evidence", action: "PackageManifest", method: "GET", path: "/complaints/{complaintId}/evidence/package-manifest",
    params: [{"name": "complaintId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_Upload_POST_SOURCE_3", controller: "EvidenceController", controllerGroup: "Evidence", action: "Upload", method: "POST", path: "/complaints/{complaintId}/evidence/upload",
    params: [{"name": "complaintId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_Delete_DELETE_SOURCE_4", controller: "EvidenceController", controllerGroup: "Evidence", action: "Delete", method: "DELETE", path: "/complaints/{complaintId}/evidence/{evidenceId}",
    params: [{"name": "complaintId", "type": "String", "required": true}, {"name": "evidenceId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_Download_GET_SOURCE_5", controller: "EvidenceController", controllerGroup: "Evidence", action: "Download", method: "GET", path: "/complaints/{complaintId}/evidence/{evidenceId}/download",
    params: [{"name": "complaintId", "type": "String", "required": true}, {"name": "evidenceId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_PackageExport_POST_SOURCE_6", controller: "EvidenceController", controllerGroup: "Evidence", action: "PackageExport", method: "POST", path: "/evidence/package-export",
    params: [],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_GetPackageExport_GET_SOURCE_7", controller: "EvidenceController", controllerGroup: "Evidence", action: "GetPackageExport", method: "GET", path: "/evidence/package-export/{packageId}",
    params: [{"name": "packageId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_DownloadPackageExport_GET_SOURCE_8", controller: "EvidenceController", controllerGroup: "Evidence", action: "DownloadPackageExport", method: "GET", path: "/evidence/package-export/{packageId}/download",
    params: [{"name": "packageId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_UploadStandalone_POST_SOURCE_9", controller: "EvidenceController", controllerGroup: "Evidence", action: "UploadStandalone", method: "POST", path: "/evidence/upload",
    params: [],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_GetEvidenceMetadata_GET_SOURCE_10", controller: "EvidenceController", controllerGroup: "Evidence", action: "GetEvidenceMetadata", method: "GET", path: "/evidence/{evidenceId}",
    params: [{"name": "evidenceId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_DownloadStandalone_GET_SOURCE_11", controller: "EvidenceController", controllerGroup: "Evidence", action: "DownloadStandalone", method: "GET", path: "/evidence/{evidenceId}/download",
    params: [{"name": "evidenceId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
  {
    key: "Evidence_IssueDownloadToken_POST_SOURCE_12", controller: "EvidenceController", controllerGroup: "Evidence", action: "IssueDownloadToken", method: "POST", path: "/evidence/{evidenceId}/download-token",
    params: [{"name": "evidenceId", "type": "String", "required": true}],
    frontendArea: "evidence-security", risk: "core",
  },
] as const satisfies readonly CmtsBackendEndpoint[];

export const CMTS_SOURCE_ONLY_ENDPOINT_KEYS = CMTS_SOURCE_ONLY_ENDPOINTS.map((endpoint) => endpoint.key) as readonly string[];
